import React from 'react'
import { withRouter } from 'react-router'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './ProductItemList.css'
import IconUploadButtonUI from "../../../widgets/action/IconUploadButtonUI";

const ProductItemListUI = ({context, messageList, inventoryItemList,
    // filters
    searchFilter, onSearchFilterChange,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick, onUploadSubmit}) =>
  <div className='c_prd_itms'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onUploadSubmit={onUploadSubmit}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI>
      {
        inventoryItemList.map((productItem, i) =>
          <ProductItemRowUI key={i} context={context} productItem={productItem}
            messageList={messageList} onRowClick={onRowClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const ActionLeftUI = ({context, messageList, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onUploadSubmit}) =>
  <React.Fragment>
    {
      selectedCount === 0 &&
      <div className='g_flex_h'>
        <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
        <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_product_item' />
        <IconUploadButtonUI messageList={messageList} icon='icon-upload' onClick={onUploadSubmit} labelKey='c_upload_csv' />
      </div>
    }
    {
      selectedCount > 0 &&
      <div className='action g_flex_h'>
        {
          selectedCount === 1 &&
          <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} labelKey='c_update_product_item' />
        }
        <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} labelKey='c_delete_product_item' />
      </div>
    }
  </React.Fragment>

const ActionTopRightUI = ({context, messageList, searchFilter, onSearchFilterChange}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

const ProductItemRowUI = ({context, messageList, productItem, onRowClick}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} productItem={productItem} onRowClick={onRowClick} />}
    right={<RowRightUI productItem={productItem} messageList={messageList} />}
    onClick={onRowClick}
    rowId={productItem.id}
  />

const RowLeftUI = ({context, productItem, onRowClick}) =>
  <React.Fragment>
    {/* if React.Fragment is replaced with html element
      must add flex to the html element */}
    <input type="checkbox" className='checkbox' checked={productItem.selected} onChange={() => {}} />
    <div className='name'>
      <div className='g_muted'>{productItem.maker}</div>
      <div>{productItem.name}</div>
      <div className='g_muted'>{productItem.category}</div>
    </div>
  </React.Fragment>

const RowRightUI = ({productItem, messageList}) =>
  <span>{productItem.salesRateF1}</span>

export default withRouter(ProductItemListUI)
